import React, { useContext } from 'react';
import { theme, Icon } from '@kueski-dev/kueski-design-system';

import { ConfigContext } from 'Contexts/Config';
import { Button } from 'Components/ProfileMultiProduct/components/designSystem';
import { useLogout } from 'Hooks/useLogout';

import { FeatureFlagsContext } from '../FeatureFlagsToggle/FeatureFlagsToggle.models';
import { LogoutButton } from './LogoutToggle.styles';

const { color } = theme;

// Keep component hook separated from flag hook
const LogoutToggleComponent = () => {
  const { closeSession } = useLogout();

  return (
    <LogoutButton>
      <Button onClick={() => closeSession()} padding={10}>
        <Icon fillColor={color.white} name="Logout" width={24} height={24} />
      </Button>
    </LogoutButton>
  );
};

export const LogoutToggle = () => {
  const {
    state: { DEVTOOLS: areDevToolsEnabled },
  } = useContext(ConfigContext) as FeatureFlagsContext;
  if (!areDevToolsEnabled) return null;

  return (<LogoutToggleComponent />);
};
